/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Tea_LotsInputs */

const vi_nav_tea_lots = /** @type {(inputs: Nav_Tea_LotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô chè`)
};

/**

* @param {Nav_Tea_LotsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_tea_lots = /** @type {((inputs?: Nav_Tea_LotsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Tea_LotsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_tea_lots(inputs)
});